import { ButtonPrimary } from '../../../../../components/ButtonPrimary';
import { LoadingSpiner } from '../../../../../components/LoadingSpinner';
import { ConfigForm } from './Components';
import styles from './SetupIPADadosDeConcorrencia.module.scss';
import { useSetupIPAConfig } from './hooks/useSetupIPAConfig';

const SetupIPADadosDeConcorrencia = () => {
  const { createConfig, updateConfig, isLoading, isSaving, data, error, refetch } = useSetupIPAConfig();

  if (error) {
    return (
      <div className={styles['setup-ipa__load-error']} role="alert">
        <h3>Não foi possível carregar as configurações</h3>
        <p>Tente novamente para recuperar os dados de concorrência.</p>
        <ButtonPrimary type="button" theme="ghost" onClick={() => refetch()}>
          Tentar novamente
        </ButtonPrimary>
      </div>
    );
  }

  return (
    <div className={styles['setup-ipa__main-config-container']}>
      {isLoading && <LoadingSpiner size="md" />}
      <ConfigForm data={data} createConfig={createConfig} updateConfig={updateConfig} isLoading={isLoading} isSaving={isSaving} />
    </div>
  );
};

export default SetupIPADadosDeConcorrencia;
